import { Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import SiteLayout from './layout/SiteLayout';
import AboutPage from '../pages/AboutPage';
import BookCallPage from '../pages/BookCallPage';
import ContingentSearchPage from '../pages/ContingentSearchPage';
import HomePage from '../pages/HomePage';
import HowItWorksPage from '../pages/HowItWorksPage';
import IndustriesPage from '../pages/IndustriesPage';
import PipeliningPage from '../pages/PipeliningPage';
import BlogIndexPage from '../pages/BlogIndexPage';
import BlogPostPage from '../pages/BlogPostPage';
import ResourcesPage from '../pages/ResourcesPage';
import RetingentRecruitmentPage from '../pages/RetingentRecruitmentPage';
import RetainedSearchPage from '../pages/RetainedSearchPage';
import RolesWeFillPage from '../pages/RolesWeFillPage';

import 'react-toastify/dist/ReactToastify.css';

export default function App() {
  return (
    <>
      <ToastContainer position="top-right" theme="colored" newestOnTop />
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/roles-we-fill" element={<RolesWeFillPage />} />
          <Route path="/industries" element={<IndustriesPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/blog" element={<BlogIndexPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/book-a-call" element={<BookCallPage />} />
          <Route path="/solutions/contingent-search" element={<ContingentSearchPage />} />
          <Route path="/solutions/retained-search" element={<RetainedSearchPage />} />
          <Route path="/solutions/retingent-recruitment" element={<RetingentRecruitmentPage />} />
          <Route path="/solutions/pipelining-talent-infrastructure" element={<PipeliningPage />} />
        </Route>
      </Routes>
    </>
  );
}
